<template>
  <div>
    <div class="ticket-coupon-wrap">
      <div class="ticket-coupon">
        <p class="ticket-coupon-tit">쿠폰등록</p>
        <img src="../../assets/images/ticket/icon-coupon-l.png" alt=""/>
        <p class="ticket-coupon-text">쿠폰번호에 숫자 0,1은 없습니다.<br/>영문자 O,I와 혼동하지 않도록 유의해주세요.</p>
        <div class="ticket-coupon-input">
          <input v-model="couponText" @input="changeCouponText()" type="text" title="쿠폰번호 입력영역" placeholder="쿠폰 번호를 등록하세요">
          <button @click="registerCoupon()">등록하기</button>
        </div>
        <div class="coupon-noti">
          <p class="dot-text"><span>쿠폰으로 지급되는 상품은 기존 보유 상품과 중복되어 적용되므로 가급적<br/>이용중인 상품이 만료 된 뒤에 쿠폰을 사용해 주세요.</span>
          </p>
          <p class="dot-text"><span>유효기간이 지난 쿠폰은 등록하실 수 없습니다.</span></p>
          <p class="dot-text"><span>등록하신 쿠폰은 환불되지 않습니다.</span></p>
          <p class="dot-text"><span>쿠폰은 상업적 용도로 사용하거나 매매하실 수 없습니다.</span></p>
        </div>
      </div>
      <div class="ticket-coupon">
        <p class="ticket-coupon-tit">코인충전</p>
        <img src="../../assets/images/ticket/icon-coin-l.png" alt=""/>
        <p class="ticket-coupon-text">코인을 충전하시면 단건 구매시 쉽고 빠르게<br/>구매하실 수 있습니다.</p>
        <div class="ticket-coupon-input">
          <button @click="registerCoin()">충전하기</button>
        </div>
        <div class="coupon-noti">
          <p class="dot-text">
            <span>충전하신 코인의 유효기간은 5년이며 유효기간이 지난 코인은 소멸되어<br/>사용하실 수 없습니다.</span></p>
          <p class="dot-text"><span>한 ID당 보유할 수 있는 총 코인은 20만원 이하입니다. </span></p>
          <p class="dot-text"><span>자동결제 시 보유 코인이 20만원 이상인 경우 자동으로 결제가 해지됩니다.</span></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { postMycouponsRegister } from '@/common/utils/request'
import constant from '@/common/resources/constant'
import { commonErrorProcess, showCoinPopup } from '@/common/utils/common'

export default {
  data () {
    return {
      couponText: ''
    }
  },
  methods: {
    // 쿠폰 번호가 입력되면 4자리마다 '-' 추가
    changeCouponText () {
      let couponText = this.couponText.replace(/-/g, '')
      let changeText = ''
      for (let i = 0; i < Math.ceil(couponText.length / 4); i++) {
        if (i !== 0) {
          changeText += '-'
        }
        changeText += couponText.slice(i * 4, Math.min(couponText.length, (i * 4) + 4))
      }
      this.couponText = changeText
    },
    registerCoupon () {
      let couponText = this.couponText.replace(/-/g, '').trim()
      if (couponText.length === 0) {
        alert(constant.MSG_MYPOOQ_COUPON_NO_VALUE)
        return
      }

      postMycouponsRegister({ couponnumber: couponText }).then(({ data }) => {
        if (data.coupontypeid === '3' && confirm(constant.MSG_MOVING_MYPOOQ_COIN)) {
          this.$router.push('/mypooq/coin')
        } else if (data.coupontypeid !== '3' && confirm(constant.MSG_MOVING_MYPOOQ_COUPON)) {
          this.$router.push('/mypooq/coupon')
        }
      }).catch((error) => {
        if (error.response && error.response.status === 550) {
          if (error.response.data.resultcode === '210') {
            const moveToLoginPage = confirm(error.response.data.resultmessage)
            if (moveToLoginPage) {
              location.href = `/login?referer=${encodeURIComponent(location.pathname + location.search)}`
            }
          } else {
            commonErrorProcess(error)
          }
        }
      })
    },
    registerCoin () {
      showCoinPopup({ returnUrl: `${location.origin}/callback.html?action=ClosePopup` })
    }
  }
}
</script>
<style lang="css" src="@/assets/css/ticket.css"></style>
